import React, {useState} from "react";
import {Page} from "../../components/page/page";
import {ChooseList} from "../../components/choose-list/choose-list";
import {useDispatch} from "react-redux";

const options = [
  {
    title: "Build stronger friendships",
    icon: "🤝",
  },
  {
    title: "Understand myself better",
    icon: "💡",
  },
  {
    title: "Discover my life path & purpose",
    icon: "🔮",
  },
  {
    title: "Grow spiritually",
    icon: "🧘‍♀️",
  },
  {
    title: "Find happiness",
    icon: "😊",
  },
  {
    title: "Improve finances",
    icon: "💰",
  },
  {
    title: "Have a successful career",
    icon: "💼",
  },
];

const AdditionalGoalsPage = () => {
  const dispatch = useDispatch();
  const [selectedOptions, setSelectedOptions] = useState([]);

  const handleChange = (selectedOptions) => {
    setSelectedOptions(selectedOptions);
  };

  return (
    <Page
      title="In addition to your relationship goals, what other goals do you want to achieve?"
      nextPageLink="../feel-insecure"
      currentStep="16"
      canGoToNextPage={selectedOptions.length >= 1}
      onContinue={() => {
        // dispatch((selectedOptions)); // TODO
      }}
    >
      <ChooseList options={options} maxSelected={7} onChange={handleChange} />
    </Page>
  );
};

export { AdditionalGoalsPage };
